import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CustomButton from "common/components/Button/Button"
import { DEFAULT_CURRENCY_SYMBOL } from "features/Contactos/constants/index"
import { getJoinedConceptos } from "features/Crear/redux/selectors/newDocumentoSelectors"
import {
  deleteConcepto,
  recalculate,
  setConceptoToEdit,
  setConceptos,
} from "features/Crear/redux/slices/newDocumentoSlice"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"
import { useCurrency } from "../../../../common/hooks/useCurrency"
import { getNewDocumentCurrency } from "../../redux/selectors/newDocumentoSettingsSelectors"
import { setShowConceptosModal } from "../../redux/slices/newDocumentoSettingsSlice"
import SearchArticulosComponent from "../SearchArticulos"
import ConceptosTableHeader from "./ConceptosTableHeader"
import { formatImpuesto, formats } from "./utils"

export const ButtonAction = ({
  className = "",
  classNameIcon = "",
  style,
  onClick,
  iconName,
}: $TSMigrationFixMe) => (
  <Button
    style={style}
    className={`icon-size-lg p-button-text btn-concept no-bg ${className}`}
    onClick={onClick}
  >
    <FontAwesomeIcon
      icon={["fal", iconName]}
      className={classNameIcon}
    />
  </Button>
)

export const CellAddRowAction = ({ onAdd, onDelete }: $TSMigrationFixMe) => (
  <td>
    <div className='d-flex justify-content-end'>
      <ButtonAction
        onClick={onAdd}
        iconName='pen'
        classNameIcon='btn-concept__icon'
      />

      <ButtonAction
        style={{ color: "red" }}
        classNameIcon='btn-concept__icon btn-concept__icon--delete'
        onClick={onDelete}
        iconName='xmark'
      />
    </div>
  </td>
)

const ConceptosTable = ({
  SearchArticulos = false,
  isLibrado,
  initialEmpresa,
  sinValorar,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const conceptos = useSelector(getJoinedConceptos)
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxes } = useTaxes()
  const handleOnCreateConcepto = () => {
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setConceptoToEdit(null))
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setShowConceptosModal(true))
    dispatch(setConceptos(conceptos))
  }

  const handleOnEditConcepto = (conceptoSelected: $TSMigrationFixMe) => {
    dispatch(setConceptoToEdit(conceptoSelected))
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setShowConceptosModal(true))
    dispatch(setConceptos(conceptos))
  }

  const handleOnDeleteConcepto = (concepto: $TSMigrationFixMe) => {
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(deleteConcepto({ concepto, conceptos }))
    dispatch(recalculate())
  }
  const { currencyList } = useCurrency()
  const currency = useSelector(getNewDocumentCurrency)
  const currencyData = currencyList?.find(
    ({ abreviatura }) => abreviatura === currency
  )

  return (
    <>
      <table>
        <ConceptosTableHeader
          sinValorar={sinValorar}
          handleOnCreateConcepto={handleOnCreateConcepto}
        />
        <tbody>
          {conceptos?.map((concepto: $TSMigrationFixMe) => (
            <tr key={concepto.id}>
              <td>{concepto.concepto}</td>

              <td>{concepto.cantidad}</td>

              {!sinValorar && (
                <>
                  <td>
                    {formats
                      .precio(concepto.precioVenta)
                      ?.replace(DEFAULT_CURRENCY_SYMBOL, "") +
                      // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
                      currencyData?.simbolo}
                  </td>
                  <td>
                    {concepto.impuestoArticuloTipoId
                      ? formatImpuesto(
                          taxes.find(
                            (taxe) =>
                              // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
                              taxe.id === concepto.impuestoArticuloTipoId
                            // @ts-expect-error TS(2339): Property 'grupoImpuesto' does not exist on type 'n...
                          )?.grupoImpuesto?.categoria,
                          concepto.impuestoArticuloPorcentaje
                        )
                      : "0%"}
                  </td>

                  <td>
                    {formats
                      .total(concepto.subtotal)
                      ?.replace(DEFAULT_CURRENCY_SYMBOL, "") +
                      // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
                      currencyData?.simbolo}
                  </td>
                </>
              )}

              <CellAddRowAction
                onAdd={() => handleOnEditConcepto(concepto)}
                onDelete={() => handleOnDeleteConcepto(concepto)}
              />
            </tr>
          ))}
        </tbody>
      </table>

      {!conceptos?.length && (
        <>
          {SearchArticulos ? (
            <div className='items-center justify-start px-3 py-2 w-100 d-flex'>
              <SearchArticulosComponent
                isLibrado={isLibrado}
                initialEmpresa={initialEmpresa}
              />
            </div>
          ) : (
            <div className='empty-field'>
              <CustomButton
                className='!tw-bg-primary'
                onClick={handleOnCreateConcepto}
              >
                {t("crear.facturaRec.addConceptLabel")}
              </CustomButton>
            </div>
          )}
        </>
      )}

      {conceptos?.length > 0 && (
        <>
          {SearchArticulos ? (
            <div className='items-center justify-start px-3 py-2 w-100 d-flex'>
              <SearchArticulosComponent
                isLibrado={isLibrado}
                initialEmpresa={initialEmpresa}
              />
            </div>
          ) : (
            <div className='mt-3 d-flex justify-content-center'>
              <p
                onClick={handleOnCreateConcepto}
                className='blue-gedesco-link'
              >
                + {t("crear.facturaRec.addNewConceptLabel")}
              </p>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default ConceptosTable
